import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/node_modules/.pnpm/@wp+next-compose-middlewares@0.2.0/node_modules/@wp/next-compose-middlewares/dist/ClientCookies.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/packages/next_public/src/modules/pricing/index.tsx");
